<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:settings') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:setting.setting') })"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editSetting"
            @clickedAddButton="editSetting"
            :addBtn="true"
            sortBy="key"
        />

      </v-col>
    </v-row>

    <SettingForm
        @updateTable="updateTableAfterManipulation"
        ref="settingForm" />

  </div>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import SettingService from '@/modules/settings/services/setting-service';
import Setting from '@/modules/settings/data/setting';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import SettingForm from "@/modules/settings/views/settings/setting/SettingForm";

export default {
  name: "SettingTable",
  components: {
    SettingForm,
    DataTablePaginated
  },
  data() {
    return {
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('settings/settings:setting.key'), value: 'key'},
        {text: this.$t('settings/settings:setting.value'), value: 'value'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      SettingService.readAllSettingsPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Setting);
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:setting.setting')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editSetting(setting) {
      this.$refs.settingForm.initialization(setting);
    }
  }
}
</script>